import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './containers/App/App';
import reportWebVitals from './reportWebVitals';
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop';
import './styles/global.css';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </Router>
  </React.StrictMode>,
);

reportWebVitals();
